<template>
  <div id="baseFooter" class="bg-variant w-full py-5">
    <div class="grid grid-cols-12 gap-10">
        <!-- Col-1 -->
        <div class="col-start-2 col-span-1">
          <div class="flex items-center">
            <router-link to="/" class="flex flex-no-shrink items-center py-3 text-grey-darkest logo-container" v-if="!this.$route.meta.sidebar" title="Retourner à l'accueil">
                <img :src="logo" alt="CodeSnippet"/>
            </router-link>
          </div>
        </div>
        <div class="col-span-6 flex flex-col justify-center">
            <!-- Links -->
            <router-link class="link" :to="{ name: 'Guide' }">
                <span>Le guide</span>
            </router-link>
            <router-link class="link" :to="{ name: 'CGU' }">
                <span>Conditions d'utilisation</span>
            </router-link>
            <!-- 
              <router-link class="link" to="/">
                <span>Accueil</span>
              </router-link> 
            -->
        </div>
        <!-- 
        <div class="col-span-4 flex flex-col justify-center">
            <router-link class="link" :to="{ name: 'Policy' }">
                <span>Politique de confidentialité</span>
            </router-link> 
        </div> 
        -->
        <div class="col-span-2 col-end-12 flex flex-col justify-center">
            <span>© {{new Date().getFullYear()}} - CodeSnippet</span>
            <span>Made with ☕, 🥞 and ❤️</span>
        </div>
    </div>
  </div>
</template>

<script>

import logo from '~/assets/logo.png';

export default {
  name: 'BaseFooter',
  data: () => ({
    logo: logo,
  }),
};
</script>
